export default __webpack_public_path__ + "static/media/three.3042c2bb.jpg";